import React, { Component } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "reactstrap";

//*************************************************************************
//YD (26/05/2021) : ajout de commentaires
//
//*************************************************************************

export class EUIPage extends Component {

    static defaultProps = {
        baseUrl: "/",
        buttons: [],
        onglets: [] // {url, titre, disabled, hidden}
    };

    _renderLink = (url, disabled, titre) => {
        if (disabled)
            return <NavLink disabled={disabled}>{titre}</NavLink>

        return <NavLink tag={Link} className="text-dark" to={url} disabled={disabled}>{titre}</NavLink>
    };

    render = () => {

        const chemin = window.location.pathname;

        //récupère l'url de base + onglets + boutons
        const { baseUrl, onglets, buttons } = this.props;

        //on affiche si on pointe bien sur l'url
        const onAffiche = (chemin === baseUrl || typeof onglets.find(onglet => chemin.startsWith(baseUrl + onglet.url)) !== "undefined");

        //construction des lis
        const listeDeLI = onAffiche && onglets.map((onglet, index) => {
            const { url, titre, disabled, hidden } = onglet;
            const urlComplete = baseUrl + url;
            return !hidden && <li key={index} className={`nav-item ${chemin.startsWith(urlComplete) ? `active` : ""}`}>{this._renderLink(urlComplete, disabled, titre)}</li>
        });

        return <nav className="navbar navbar-expand-lg navbar-light border-bottom">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                    <li className="nav-item"><NavLink tag={Link} className="text-dark" to="/">Accueil</NavLink></li>
                    {listeDeLI}
                </ul>
            </div>
            {buttons}
        </nav>;
    };
}